/**
 * returns an array of truthy arguments
 */
export function asNonNullArray<T>(...data: (T | null | undefined)[]): T[] {
  return data.filter((e) => e) as T[];
}
